var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58841 0H24.4116C28.6027 0 32 3.39732 32 7.5884V24.4116C32 28.6027 28.6027 32 24.4116 32H7.58841C3.39733 32 0 28.6027 0 24.4116V7.5884C0 3.39732 3.39733 0 7.58841 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1311 0.867188H8.86084C4.44256 0.867188 0.86084 4.44891 0.86084 8.86719V23.1375C0.86084 27.5557 4.44256 31.1375 8.86084 31.1375H23.1311C27.5494 31.1375 31.1311 27.5557 31.1311 23.1375V8.86719C31.1311 4.44891 27.5494 0.867188 23.1311 0.867188Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2539 22.9046L17.5742 14.6531L16.9321 13.7199L12.8691 7.81728L12.5324 7.32812H7.54004L8.75766 9.09755L14.1598 16.9467L14.802 17.8789L19.1425 24.1854L19.4792 24.6742H24.4717L23.2539 22.9046ZM20.0725 23.5446L15.5631 16.9927L14.921 16.0601L9.68832 8.45742H11.9392L16.171 14.6059L16.8131 15.5385L22.3236 23.5446H20.0725Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.921 16.0625L15.5631 16.9952L14.8018 17.8812L8.96088 24.6763H7.52051L14.1597 16.9489L14.921 16.0625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8706 7.32812L17.5743 14.6531L16.813 15.5385L16.1709 14.6059L16.9322 13.7199L21.1972 8.75565L22.4302 7.32812H23.8706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ba193a478a8b7f5aa317ea3cc0386059.svg";
export { ForwardRef as ReactComponent };